var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4258_39501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9922 24.4766C18.6067 24.4766 23.9688 19.1145 23.9688 12.5C23.9688 5.88553 18.6067 0.523438 11.9922 0.523438C5.37772 0.523438 0.015625 5.88553 0.015625 12.5C0.015625 19.1145 5.37772 24.4766 11.9922 24.4766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10156 12.5554L10.232 17.6858L18.8749 9.04286L17.1602 7.32812L10.232 14.2563L6.8163 10.8406L5.10156 12.5554Z",
    fill: "#17C76C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4258_39501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.48f6813fef55e8d3ee5680562d0b6b0c.svg";
export { ForwardRef as ReactComponent };